"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var badge_1 = require("./badge");
var button_1 = require("./button");
var card_1 = require("./card");
var checkbox_1 = require("./checkbox");
var chip_1 = require("./chip");
var collapsible_1 = require("./collapsible");
var collection_1 = require("./collection");
var datepicker_1 = require("./datepicker");
var dropdown_1 = require("./dropdown");
var feature_discovery_1 = require("./feature-discovery");
var icon_1 = require("./icon");
var icon_mdi_1 = require("./icon-mdi");
var input_1 = require("./input");
var media_1 = require("./media");
var modal_1 = require("./modal");
var navbar_1 = require("./navbar");
var pagination_1 = require("./pagination");
var parallax_1 = require("./parallax");
var progress_1 = require("./progress");
var radio_button_1 = require("./radio-button");
var select_1 = require("./select");
var shared_1 = require("./shared");
var sidenav_1 = require("./sidenav");
var spinner_1 = require("./spinner");
var switch_1 = require("./switch");
var tab_1 = require("./tab");
var textarea_1 = require("./textarea");
var timepicker_1 = require("./timepicker");
var toast_1 = require("./toast");
var tooltip_1 = require("./tooltip");
var validation_1 = require("./validation");
var MZ_MODULES = [
    common_1.CommonModule,
    forms_1.FormsModule,
    badge_1.MzBadgeModule,
    button_1.MzButtonModule,
    card_1.MzCardModule,
    checkbox_1.MzCheckboxModule,
    chip_1.MzChipModule,
    collapsible_1.MzCollapsibleModule,
    collection_1.MzCollectionModule,
    datepicker_1.MzDatepickerModule,
    dropdown_1.MzDropdownModule,
    feature_discovery_1.MzFeatureDiscoveryModule,
    icon_1.MzIconModule,
    icon_mdi_1.MzIconMdiModule,
    shared_1.MzInjectionModule,
    input_1.MzInputModule,
    media_1.MzMediaModule,
    modal_1.MzModalModule,
    navbar_1.MzNavbarModule,
    pagination_1.MzPaginationModule,
    parallax_1.MzParallaxModule,
    progress_1.MzProgressModule,
    radio_button_1.MzRadioButtonModule,
    select_1.MzSelectModule,
    sidenav_1.MzSidenavModule,
    spinner_1.MzSpinnerModule,
    switch_1.MzSwitchModule,
    tab_1.MzTabModule,
    textarea_1.MzTextareaModule,
    timepicker_1.MzTimepickerModule,
    toast_1.MzToastModule,
    tooltip_1.MzTooltipModule,
    validation_1.MzValidationModule,
];
/* Deprecated */
var MaterializeModule = (function () {
    function MaterializeModule() {
    }
    MaterializeModule.forRoot = function () {
        return {
            ngModule: MaterializeModule,
        };
    };
    return MaterializeModule;
}());
MaterializeModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: MZ_MODULES,
                exports: MZ_MODULES,
            },] },
];
/** @nocollapse */
MaterializeModule.ctorParameters = function () { return []; };
exports.MaterializeModule = MaterializeModule;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/materialize.module.js
// module id = ./node_modules/ng2-materialize/dist/materialize.module.js
// module chunks = vendor